import { useMemo } from 'react';

import type { WalletSliceKey } from '../types/wallet-slice.type';
import { useWalletStore } from './useWalletStore';
import { useSuiWallet } from './useSuiWallet';
import { useZkLoginWallet } from './useZkLoginWallet';

type WalletTypeState = {
	primaryWalletType: WalletSliceKey | null;
	connectedWalletType: WalletSliceKey | null;
	activeWalletType: WalletSliceKey | null;
};

export function useWalletType(): WalletTypeState {
	const primaryWalletType = useWalletStore((state) => state.primaryWalletType);
	const { currentWallet: suiCurrentWallet } = useSuiWallet();
	const { currentWallet: zkLoginCurrentWallet } = useZkLoginWallet();

	const connectedWalletType = useMemo<WalletSliceKey | null>(() => {
		if (zkLoginCurrentWallet) {
			return 'zkLoginWallet';
		}
		if (suiCurrentWallet) {
			return 'suiWallet';
		}
		return null;
	}, [suiCurrentWallet, zkLoginCurrentWallet]);

	const activeWalletType = useMemo<WalletSliceKey | null>(() => primaryWalletType ?? connectedWalletType, [primaryWalletType, connectedWalletType]);

	return {
		primaryWalletType,
		connectedWalletType,
		activeWalletType,
	};
}
